<div class="flex flex-col gap-4 text-sm">
  @if (openTickets > 0) {
  <p class="rounded bg-yellow-50 p-2 text-yellow-800">Tickets abiertos: {{ openTickets }}</p>
  } @if (loading) {
  <div class="h-16 w-full animate-pulse rounded bg-gray-100"></div>
  } @else {
  <ul class="flex flex-col gap-2">
    @for (note of notes; track note.id) {
    <li class="rounded border border-gray-200 p-3" [class.opacity-60]="note.is_resolved">
      @if (note.subject || note.status_label) {
      <p class="mb-1 font-semibold">
        {{ note.subject }} @if (note.status_label) {
        <span class="ml-1 rounded bg-gray-100 px-1.5 py-0.5 text-xs font-normal"
          >{{ note.status_label }}</span
        >
        }
      </p>
      }
      <p class="whitespace-pre-line">{{ note.note }}</p>
      @for (reply of note.replies; track $index) {
      <p class="ml-4 mt-1 whitespace-pre-line border-l-2 pl-2 text-gray-600">
        {{ reply.note }}
        <span class="text-xs text-gray-400"
          >— {{ reply.user_name }} {{ reply.created_at_label }}</span
        >
      </p>
      }
      <div class="mt-2 flex flex-wrap items-center justify-between gap-2 text-xs text-gray-500">
        <span>
          {{ note.user_name }} · {{ note.created_at_label }} @if (note.assignee_name) { · Asignada a
          {{ note.assignee_name }} } @if (note.is_resolved && note.resolver_name) { · Resuelta por
          {{ note.resolver_name }} {{ note.resolved_at_label }} }
        </span>
        <span class="flex gap-1">
          @if (note.can_reply) {
          <p-button
            label="Responder"
            [text]="true"
            size="small"
            (onClick)="replyingId = replyingId === note.id ? null : note.id"
          />
          } @if (note.can_assign || note.can_reassign) {
          <p-button
            [label]="note.assigned_user_id ? 'Reasignar' : 'Asignar'"
            [text]="true"
            size="small"
            (onClick)="assigningId = assigningId === note.id ? null : note.id"
          />
          } @if (note.can_reopen) {
          <p-button
            label="Reabrir"
            [text]="true"
            size="small"
            (onClick)="run('note_reopen', note)"
          />
          } @if (note.can_resolve) {
          <p-button
            label="Resolver"
            [text]="true"
            size="small"
            severity="success"
            (onClick)="run('note_resolve', note)"
          />
          } @if (note.can_delete) {
          <p-button
            icon="pi pi-trash"
            [text]="true"
            size="small"
            severity="danger"
            (onClick)="remove(note)"
          />
          }
        </span>
      </div>
      @if (replyingId === note.id) {
      <div class="mt-2 flex gap-2">
        <input
          pInputText
          class="flex-1"
          placeholder="Respuesta"
          [(ngModel)]="replyText"
          (keyup.enter)="reply(note)"
        />
        <p-button
          label="Enviar"
          size="small"
          [disabled]="!replyText.trim()"
          (onClick)="reply(note)"
        />
      </div>
      } @if (assigningId === note.id) {
      <div class="mt-2 flex gap-2">
        <p-dropdown
          class="flex-1"
          [options]="assignees"
          optionLabel="label"
          optionValue="value"
          placeholder="Asignar a"
          appendTo="body"
          [(ngModel)]="assignTo"
        />
        <p-button label="Asignar" size="small" [disabled]="!assignTo" (onClick)="assign(note)" />
      </div>
      }
    </li>
    } @empty {
    <li class="text-gray-500">Esta ONU no tiene notas.</li>
    }
  </ul>
  @if (pageCount > 1) {
  <div class="flex items-center justify-center gap-2">
    <p-button
      icon="pi pi-chevron-left"
      [text]="true"
      [disabled]="page <= 1"
      (onClick)="load(page - 1)"
    />
    <span>Página {{ page }} de {{ pageCount }}</span>
    <p-button
      icon="pi pi-chevron-right"
      [text]="true"
      [disabled]="page >= pageCount"
      (onClick)="load(page + 1)"
    />
  </div>
  } }

  <div class="flex flex-col gap-2 border-t pt-3">
    <textarea
      pInputTextarea
      rows="2"
      maxlength="500"
      placeholder="Agregar una nota sobre esta ONU"
      [(ngModel)]="text"
    ></textarea>
    <div class="flex flex-wrap items-center justify-between gap-2">
      <p-dropdown
        [options]="assignees"
        optionLabel="label"
        optionValue="value"
        [showClear]="true"
        placeholder="Asignar a (opcional)"
        appendTo="body"
        [(ngModel)]="assignee"
      />
      <p-button
        label="Agregar nota"
        icon="pi pi-plus"
        [loading]="saving"
        [disabled]="!text.trim()"
        (onClick)="add()"
      />
    </div>
  </div>
</div>
